import { render } from "./BasicDataBasicLayout.vue?vue&type=template&id=a3d92b64"
import script from "./BasicDataBasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicDataBasicLayout.vue?vue&type=script&lang=js"

import "./BasicDataBasicLayout.vue?vue&type=style&index=0&id=a3d92b64&lang=css"
script.render = render

export default script